import { defineComponent as _defineComponent } from 'vue';
import IconSelectDown from '@/components/general/icons/IconSelectDown.vue';
import IconSelectUp from '@/components/general/icons/IconSelectUp.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BLoggedUser',
  props: {
    light: {
      type: Boolean,
      default: true
    },
    email: {
      type: String,
      default: '',
      required: true
    },
    isOrganizer: {
      type: Boolean,
      default: false
    }
  },
  emits: ['profile', 'password', 'privacy', 'orders', 'api-keys', 'organizer-signup', 'logout'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var props = __props;
    var whitelabel = useWhitelabel();
    var dropdown = ref(false);
    var color = computed(function () {
      return props.light ? whitelabel.lightTheme.textPrimary.lighten5 : whitelabel.lightTheme.textPrimary.base;
    });
    function onDropDown() {
      dropdown.value = !dropdown.value;
    }
    function onClose() {
      dropdown.value = false;
    }
    expose({
      onClose: onClose
    });
    return {
      __sfc: true,
      props: props,
      whitelabel: whitelabel,
      dropdown: dropdown,
      color: color,
      onDropDown: onDropDown,
      onClose: onClose,
      IconSelectDown: IconSelectDown,
      IconSelectUp: IconSelectUp
    };
  }
});